(function () {
  const SECTION_SELECTOR = '.aseave-faq';
  const ITEM_SELECTOR = '.aseave-faq__item';
  const SUMMARY_SELECTOR = '.aseave-faq__summary';
  const TOGGLE_SELECTOR = '.aseave-faq__toggle';
  const NOTE_PARAGRAPH_SELECTOR = '.aseave-faq__answer p';

  const setExpandedState = (item) => {
    const button = item.querySelector(TOGGLE_SELECTOR);
    if (!button) return;
    const isCollapsed = item.getAttribute('data-collapsed') === 'true';
    const expanded = item.open && !isCollapsed;
    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  };

  const collapseItem = (item) => {
    item.setAttribute('data-collapsed', 'true');
    setExpandedState(item);
  };

  const expandItem = (item) => {
    item.removeAttribute('data-collapsed');
    setExpandedState(item);
  };

  const handleToggleClick = (event, section) => {
    const button = event.target.closest(TOGGLE_SELECTOR);
    if (!button || !section.contains(button)) return false;

    event.preventDefault();
    event.stopPropagation();

    const item = button.closest(ITEM_SELECTOR);
    if (!item) return true;

    // シンプルに現在の状態を反転させる
    const isCollapsed = item.getAttribute('data-collapsed') === 'true';

    if (item.open && !isCollapsed) {
      // 開いている状態 → 閉じる
      collapseItem(item);
    } else {
      // 閉じている状態 → 開く
      item.open = true;
      expandItem(item);
    }

    return true;
  };

  const preventSummaryClick = (event, section) => {
    const summary = event.target.closest(SUMMARY_SELECTOR);
    if (!summary || !section.contains(summary)) return;

    // モバイル版（749px以下）ではsummary全体をクリック可能にする
    if (window.innerWidth <= 749) {
      return;
    }

    // デスクトップ版：ボタン以外のsummaryクリックを防ぐ
    const button = event.target.closest(TOGGLE_SELECTOR);
    if (!button) {
      event.preventDefault();
    }
  };

  const applyNoteStyles = (root) => {
    root.querySelectorAll(NOTE_PARAGRAPH_SELECTOR).forEach((paragraph) => {
      if (paragraph.textContent.trim().startsWith('※')) {
        paragraph.classList.add('aseave-faq__note');
      }
    });
  };

  const bindSection = (section) => {
    if (section.dataset.faqBound === 'true') return;
    section.dataset.faqBound = 'true';

    const items = section.querySelectorAll(ITEM_SELECTOR);
    items.forEach(setExpandedState);
    applyNoteStyles(section);

    section.addEventListener('click', (event) => {
      handleToggleClick(event, section);
      preventSummaryClick(event, section);
    });

    section.addEventListener(
      'toggle',
      (event) => {
        const item = event.target.closest(ITEM_SELECTOR);
        if (!item || !section.contains(item)) return;
        if (!item.open) {
          expandItem(item);
        } else {
          setExpandedState(item);
        }
      },
      true
    );
  };

  const initFaq = (root = document) => {
    const sections = root.querySelectorAll(SECTION_SELECTOR);
    if (!sections.length) return;
    sections.forEach(bindSection);
    applyNoteStyles(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initFaq());
  } else {
    initFaq();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initFaq(event.target);
  });

  document.addEventListener('shopify:section:reorder', () => {
    initFaq();
  });

  document.addEventListener('shopify:section:select', (event) => {
    initFaq(event.target);
  });

  document.addEventListener('shopify:section:deselect', (event) => {
    initFaq(event.target);
  });
})();
